import React, { Fragment, useCallback } from 'react';
import { MediaSection } from './MediaSection';
import { MediaSectionWithShow } from './MediaSectionWithShow';
import { Section } from './Section';
import { SectionMetaProvider } from './SectionMetaProvider';
import { ShowSection } from './ShowSection';
import { ContinueWatching } from '../../pages/Home/ContinueWatching/ContinueWatching';
import { FavoriteShows } from '../../pages/Home/FavoriteShows/FavoriteShows';
import { HomeFavoriteGuideTeaser } from '../../pages/Home/HomeFavoriteGuideTeaser/HomeFavoriteGuideTeaser';
import { MyProgram } from '../../pages/Home/MyProgram/MyProgram';
import { Recommender } from '../../pages/Home/Recommender/Recommender';
import { ShowAccess } from '../../pages/Home/ShowAccess/ShowAccess';
import { TopicSelector } from '../../pages/Home/TopicSelector/TopicSelector';
import { TvLivestreams } from '../../pages/Home/TvLivestreams/TvLivestreams';
import { WatchLater } from '../../pages/Home/WatchLater/WatchLater';
import { AvailableEpisodes } from '../../pages/Show/AvailableEpisodes/AvailableEpisodes';
import { TrendingShowsSwimlane } from '../../pages/Show/TrendingShows/TrendingShowsSwimlane';
import { jsx as _jsx } from "react/jsx-runtime";
const simpleSections = {
  TopicSelector: /*#__PURE__*/_jsx(TopicSelector, {}),
  ContinueWatching: /*#__PURE__*/_jsx(ContinueWatching, {}),
  FavoriteShows: /*#__PURE__*/_jsx(FavoriteShows, {}),
  WatchLater: /*#__PURE__*/_jsx(WatchLater, {}),
  MyProgram: /*#__PURE__*/_jsx(MyProgram, {}),
  Livestreams: /*#__PURE__*/_jsx(TvLivestreams, {}),
  FavoriteGuide: /*#__PURE__*/_jsx(HomeFavoriteGuideTeaser, {}),
  ShowAccess: /*#__PURE__*/_jsx(ShowAccess, {}),
  TrendingShowsByTopic: /*#__PURE__*/_jsx(TrendingShowsSwimlane, {}),
  AvailableEpisodes: /*#__PURE__*/_jsx(AvailableEpisodes, {}),
  Recommender: /*#__PURE__*/_jsx(Recommender, {}),
  ContinueStreaming: /*#__PURE__*/_jsx(ContinueWatching, {}),
  // New general section replacing ContinueWatching
  StreamLater: /*#__PURE__*/_jsx(WatchLater, {}) // New general section replacing WatchLater
};
export const Sections = ({
  initialData,
  sections
}) => {
  const getPlaySection = useCallback((section, index) => {
    switch (section.sectionType) {
      case 'SimpleSection':
        {
          return simpleSections[section.representation.name];
        }
      case 'MediaSection':
        {
          return /*#__PURE__*/_jsx(MediaSection, {
            section: section,
            sectionIndex: index,
            initialData: initialData
          }, section.id);
        }
      case 'ShowSection':
        {
          return /*#__PURE__*/_jsx(ShowSection, {
            section: section,
            sectionIndex: index,
            initialData: initialData
          }, section.id);
        }
      case 'MediaSectionWithShow':
        {
          return /*#__PURE__*/_jsx(MediaSectionWithShow, {
            section: section,
            sectionIndex: index,
            initialData: initialData
          }, section.id);
        }
      default:
        return null;
    }
  }, [initialData]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: sections.map((section, index) => /*#__PURE__*/_jsx(SectionMetaProvider, {
      section: section,
      children: /*#__PURE__*/_jsx(Section, {
        needsTopSpacing: index === 0 && !topSpacingExceptions.includes(section.representation.name),
        preventBottomSpacing: bottomSpacingExceptions.includes(section.representation.name),
        children: getPlaySection(section, index)
      })
    }, section.id))
  });
};
const topSpacingExceptions = ['HeroStage', 'Highlight'];
const bottomSpacingExceptions = ['HeroStage'];